// Format a JS Date to DD/MM/YYYY (UK format)
export function formatDateUK(date) {
  if (!(date instanceof Date) || isNaN(date)) return '';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}
export function parseUKDate(dateStr) {
  if (!dateStr) return new Date(NaN);

  if (typeof dateStr !== 'string') {
    return new Date(dateStr);
  }

  const str = dateStr.trim();

  // ISO format (YYYY-MM-DD) from <input type="date">
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
    return new Date(`${str}T00:00:00`);
  }

  // dd/mm/yy or dd/mm/yyyy
  let match = str.match(/^(\d{2})\/(\d{2})\/(\d{2,4})$/);
  if (match) {
    let [, day, month, year] = match;
    if (year.length === 2) year = '20' + year;
    return new Date(`${year}-${month}-${day}T00:00:00`);
  }

  // ddmmyy or ddmmyyyy
  match = str.match(/^(\d{2})(\d{2})(\d{2,4})$/);
  if (match) {
    let [, day, month, year] = match;
    if (year.length === 2) year = '20' + year;
    return new Date(`${year}-${month}-${day}T00:00:00`);
  }

  // Invalid format
  return new Date(NaN);
}
export const HEAD_CELLS = [
  'ReqType',
  'Unit',
  'EVN',
  'OldMeter',
  'NewMeter',
  'NewEFDT',
  'OldETDT',
  'Comments',
];

export function generateFileName(prefix = 'UI') {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${prefix}_${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.csv`;
}

export const prettifyHeader = (h) =>
  /^[A-Z]+$/.test(h) ? h : String(h).replace(/([A-Z])/g, ' $1').trim();

export const issuesForHeader = (header, issues = []) => {
  if (!header) return [];
  const lower = String(header).toLowerCase();
  const pretty = prettifyHeader(header).toLowerCase();
  return (issues || []).filter((issue) => {
    const s = String(issue || '').toLowerCase();
    return s.includes(lower) || s.includes(pretty);
  });
};

const REQTYPE_LABELS = {
  EM: 'EM',
  N: 'N',
};

export const labelForReqType = (rt) => (rt == null ? rt : (REQTYPE_LABELS[String(rt)] ?? String(rt)));

export function formatDateTimeForDisplay(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('en-GB');
}

const meterChangeHelpers = {
  HEAD_CELLS,
  generateFileName,
  prettifyHeader,
  issuesForHeader,
  labelForReqType,
  formatDateTimeForDisplay,
};

export default meterChangeHelpers;

export function formatName(name) {
  if (!name) return null;
  const trimmed = String(name).trim();
  if (trimmed.includes(',')) {
    const [last, first] = trimmed.split(',').map((s) => s.trim());
    if (first && last) return `${first} ${last}`;
  }
  return trimmed;
}